module.exports = __webpack_public_path__ + "img/My Demands-light.ba63385f.svg";